/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
/**
 * Selected Filter Tag.
 */
export class VxSelectedFilterTag {
    constructor() {
        /**
         * Handles the fade out state.
         */
        this.handleClick = () => {
            this.fadeTag = true;
        };
        this.label = undefined;
        this.fadeTag = false;
    }
    /**
     * If Label Change then show tag.
     */
    handleLabelPropChange() {
        this.fadeTag = false;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h(Host, { key: '0d608eff6e6785290982b6ca5b0a6bad5d4f1fb6' }, h("button", { key: 'a7ea36cf27844d7f5d73ba86d32e29f8dd5982ac', class: {
                'vx-selected-filter-tag': true,
                'fade-tag': (this.fadeTag),
            }, onClick: this.handleClick, "aria-label": `Filter ${this.label} entfernen` }, this.label)));
    }
    static get is() { return "vx-selected-filter-tag"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-selected-filter-tag.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-selected-filter-tag.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label of Tag."
                },
                "attribute": "label",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "fadeTag": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "label",
                "methodName": "handleLabelPropChange"
            }];
    }
}
//# sourceMappingURL=vx-selected-filter-tag.js.map
